import { motion } from "framer-motion";
import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import facebook from "../../Resource/image/icons/facebook_32.png";
import linkedin from "../../Resource/image/icons/linkedin_32.png";
import instagram from "../../Resource/image/icons/instagram_32.png";
import twitter from "../../Resource/image/icons/twitter_32.png";
import file from "../../Resource/Documents/Manikandan.AL.pdf";
import SocialMediaElements from "../SocialMedia/SocialMediaElements";

import useMediaQuery from "../../Hooks/useMediaQuery";
import image from "../../Resource/image/4884785.png";
export default function Landing({ SetselectedPage }) {
  const isAboveMediumSize = useMediaQuery("(min-width:1060px)");

  return (
    <section
      id="home"
      className="md:flex md:justify-between md:items-center md:h-full gap-16 py-10"
    >
      <div className="md:order-2 flex justify-center basis-3/5 z-10 mt-10 md:mt-32">
        <img
          style={{ pointerEvents: "none" }}
          className="hover:filter hover:saturate-200 transition duration-500 z-10 w-full 
                max-w-[400px] md:max-w-[600px]"
          src={image}
          alt="fullstackimage"
        />
      </div>

      <div className="z-30 basis-2/5 mt-12 md:mt-32">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <p className=" font-lato text-[2.8rem] z-10 text-center md:text-start">
            Hi, I'm {""}
            <span>
              <span className="text-red">M</span>ani
              <span className="text-red">K</span>an
              <span className="text-red">D</span>an
            </span>
          </p>
          <p className="mt-3 mb-7 text-[1.5rem] text-center md:text-start">
            I'm a full-stack developer
          </p>
          {/* <div className="flex text-center items-center flex-col ">
            <div className="border-2 border-red rounded-md py-2 px-3 hover:border-0 hover:border-transparent hover:bg-gray-600 transitio duration-500  ">
              <button>Download CV</button>
            </div>
          </div> */}
        </motion.div>

        <motion.div
          className="flex mt-5 justify-center md:justify-start flex-col md:flex-row"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <AnchorLink
            className="
            btn-grad 
            "
            onClick={() => SetselectedPage("contact")}
            href="#contact"
          >
            Contact Me
          </AnchorLink>
          <br />

          <a href={file} className="btn-grad-2" download="Resume.pdf">
            {"Resume"}
          </a>
        </motion.div>

        <motion.div
          className="flex mt-7 justify-center md:justify-start "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.8, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <SocialMediaElements
            icon={linkedin}
            url="https://in.linkedin.com/"
            style={"hover:text-blue"}
          />
          <SocialMediaElements
            icon={instagram}
            url="https://www.instagram.com/"
            style={"hover:text-red"}
          />
          <SocialMediaElements
            icon={facebook}
            url="https://www.facebook.com/"
            style={"hover:text-blue"}
          />
          <SocialMediaElements
            icon={twitter}
            url="https://twitter.com/"
            style={"hover:text-blue"}
          />
        </motion.div>
      </div>
    </section>
  );
}
